import { isArray } from "./is-array"
import { isObject } from "./is-object"

/**
 * Checks if the given value is empty.
 */

export const isEmpty = (input: unknown) => {
  return (
    input === null ||
    input === undefined ||
    (isObject(input) && Object.keys(input).length === 0) ||
    (isArray(input) && (input as unknown[]).length === 0) ||
    (typeof input === "string" && input.trim().length === 0)
  )
}
